import SpaceForButton from '@/components/_common/SpaceForButtons';
import { CashMovement } from '@/core/domain/financial/BoxMovement/BoxMovement.types';
import formatterPrice from '@/utils/number/formatterPrice';
import { Statistic } from 'antd';

interface Props {
  balance?: CashMovement;
}

export default function ListTableFooter({ balance }: Props) {
  const getBalanceValueStyle = (balanceValue: number | undefined | null) => {
    const value = balanceValue ?? 0;
    return value > 0 ? { color: 'rgb(160, 206, 51)' } : { color: '#cf4a1d' };
  };

  return (
    <SpaceForButton justifyContent="end" size={'large'}>
      <Statistic
        formatter={(value) => formatterPrice(Number(value))}
        value={balance?.previousBalance ?? 0}
        title="Saldo anterior"
      />

      <Statistic
        formatter={(value) => formatterPrice(Number(value))}
        value={balance?.totalDepartures ?? 0}
        title="Total saídas"
        valueStyle={{ color: '#cf4a1d' }}
      />

      <Statistic
        formatter={(value) => formatterPrice(Number(value))}
        value={balance?.totalEntries ?? 0}
        title="Total entradas"
        valueStyle={{ color: 'rgb(160, 206, 51)' }}
      />

      <Statistic
        formatter={(value) => formatterPrice(Number(value))}
        value={balance?.currentBalanceInPeriod ?? 0}
        title="Saldo atual do periodo"
        valueStyle={getBalanceValueStyle(balance?.currentBalanceInPeriod)}
      />

      <Statistic
        formatter={(value) => formatterPrice(Number(value))}
        value={balance?.currentBalance ?? 0}
        title="Saldo atual"
        valueStyle={getBalanceValueStyle(balance?.currentBalance)}
      />
    </SpaceForButton>
  );
}
